module.exports = __webpack_public_path__ + "img/stripe.6e8fc23a.jpg";